import ChangeLanguage from "./ChangeLanguage";
import Dropdown from "./Dropdown";
import Stepper from "./Stepper";
import TabsDemo from "./Tabs";

export { ChangeLanguage, Dropdown, Stepper, TabsDemo as Tabs };
